import React from 'react';

import { ConnectedSpaceInfoProvider } from '~src/spacesPlatform/components/Explorer/helpers/SpaceInfoProvider';
import { SpaceInfo, SpaceItemForNonEntitySpace } from '~src/spacesPlatform/state/SpaceInfo';

import { ConnectedQueryParamUpdateProvider } from '../../../app/spaces/RouterHelpers/QueryParamUpdateProvider';
import { ConnectedAllSitesSpace } from './ConnectedAllSitesSpace';

export interface AllSitesSpaceProviderProps {
  readonly routeLocationPath: string;
  readonly routeLocationSearch: string;
}

const AllSitessSpaceInfo: SpaceInfo = {
  item: SpaceItemForNonEntitySpace,
  spaceType: 'sites',
  subspaceName: undefined
};

export const AllSitesSpaceProvider: React.FunctionComponent<AllSitesSpaceProviderProps> = (props) => {
  return (
    <ConnectedSpaceInfoProvider spaceInfo={AllSitessSpaceInfo}>
      <ConnectedQueryParamUpdateProvider
        routeLocationPath={props.routeLocationPath}
        routeLocationSearch={props.routeLocationSearch}
        shouldUpdateBreadcrumbs={false}
        shouldUpdateContentTypes={false}
        shouldUpdateFilters={true}
        shouldUpdateSort={true}
      >
        <ConnectedAllSitesSpace />
      </ConnectedQueryParamUpdateProvider>
    </ConnectedSpaceInfoProvider>
  );
};
